import AiModelFilterView from '@UI/Pages/Administration/AiEngines/Sections/ModelsSection/Filters/AiModelFilterView';
import { createSignal } from '@verclam/pulsar';

const aiModelFiltersSignal = createSignal<AiModelFilterView>(AiModelFilterView.createDefault());

export const setAiModelFilters = (filters: AiModelFilterView): void => {
	aiModelFiltersSignal.value = filters;
};

export default aiModelFiltersSignal;
